/**
 * @generated SignedSource<<8551d27fa84400facf00edd420591b51>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Ordering = "ASC" | "ASC_NULLS_FIRST" | "ASC_NULLS_LAST" | "DESC" | "DESC_NULLS_FIRST" | "DESC_NULLS_LAST" | "%future added value";
export type MATUserInvoiceFilter = {
  AND?: MATUserInvoiceFilter | null;
  NOT?: MATUserInvoiceFilter | null;
  OR?: MATUserInvoiceFilter | null;
  distinct?: boolean | null;
  id?: string | null;
  id_Exact?: string | null;
  id_In?: ReadonlyArray<string> | null;
  id_Not_In?: ReadonlyArray<string> | null;
  isPaid?: boolean | null;
  userId_Exact?: string | null;
};
export type MATUserInvoiceOrder = {
  order_PaidAt?: Ordering | null;
};
export type UserInvoicePaginatorRefreshQuery$variables = {
  after?: string | null;
  filters?: MATUserInvoiceFilter | null;
  first?: number | null;
  order?: MATUserInvoiceOrder | null;
};
export type UserInvoicePaginatorRefreshQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"UserInvoicePaginator_query">;
};
export type UserInvoicePaginatorRefreshQuery = {
  response: UserInvoicePaginatorRefreshQuery$data;
  variables: UserInvoicePaginatorRefreshQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": {
      "isPaid": true
    },
    "kind": "LocalArgument",
    "name": "filters"
  },
  {
    "defaultValue": 5,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": {
      "order_PaidAt": "DESC"
    },
    "kind": "LocalArgument",
    "name": "order"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserInvoicePaginatorRefreshQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "UserInvoicePaginator_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserInvoicePaginatorRefreshQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MATUserInvoiceConnection",
        "kind": "LinkedField",
        "name": "userInvoices",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MATUserInvoiceEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MATUserInvoice",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MATInternalProduct",
                    "kind": "LinkedField",
                    "name": "product",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MATInternalItem",
                        "kind": "LinkedField",
                        "name": "item",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "premiumType",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MATInternalOrder",
                    "kind": "LinkedField",
                    "name": "order",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "paidAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "amount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "applyStartDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "applyEndDate",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__id",
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "filters",
          "order"
        ],
        "handle": "connection",
        "key": "UserInvoicePaginator_query_userInvoices",
        "kind": "LinkedHandle",
        "name": "userInvoices"
      }
    ]
  },
  "params": {
    "cacheID": "ef42844aa65dd7b443d782238877a540",
    "id": null,
    "metadata": {},
    "name": "UserInvoicePaginatorRefreshQuery",
    "operationKind": "query",
    "text": "query UserInvoicePaginatorRefreshQuery(\n  $after: String\n  $filters: MATUserInvoiceFilter = {isPaid: true}\n  $first: Int = 5\n  $order: MATUserInvoiceOrder = {order_PaidAt: DESC}\n) {\n  ...UserInvoicePaginator_query_2rfEMg\n}\n\nfragment UserInvoiceConnectionDataTable_UserInvoiceConnection on MATUserInvoiceConnection {\n  edges {\n    node {\n      id\n      product {\n        name\n        item {\n          premiumType\n          id\n        }\n        id\n      }\n      order {\n        paidAt\n        amount\n        applyStartDate\n        applyEndDate\n        id\n      }\n    }\n  }\n}\n\nfragment UserInvoicePaginator_query_2rfEMg on Query {\n  userInvoices(filters: $filters, order: $order, first: $first, after: $after) {\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      node {\n        id\n        product {\n          name\n          item {\n            premiumType\n            id\n          }\n          id\n        }\n        order {\n          paidAt\n          amount\n          applyStartDate\n          applyEndDate\n          id\n        }\n        __typename\n      }\n      cursor\n    }\n    ...UserInvoiceConnectionDataTable_UserInvoiceConnection\n  }\n}\n"
  }
};
})();

(node as any).hash = "a6d0c3f5c6d284d7cd1773f64e185a2a";

export default node;
